// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store/store'
import Vuetify from 'vuetify/es5/index'
import * as accounting from './services/accounting.min.js'
import FBSignInButton from 'vue-facebook-signin-button'
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import VueCookies from 'vue-cookies';

import 'vuetify/dist/vuetify.min.css'
import '../static/main.css'

import VueMatchHeights from 'vue-match-heights';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();
window.__forceSmoothScrollPolyfill__ = true;

// import FBGraphAPI from 'fb-graph-api';

// const FB = new FBGraphAPI({
//     clientID: '...',
//     clientSecret: '...',
//     appAccessToken: '...' // Optional
// });
//
// window.FB = FB;

Vue.use(VueMatchHeights, {
  disabled: [768], // Optional: default viewports widths to disabled resizing on. Can be overridden per usage
});

window.fbAsyncInit = function () {

    FB.init({
        appId: '465608387189710',
        cookie: true,  // enable cookies to allow the server to access the session
        xfbml: true,  // parse social plugins on this page
        version: 'v2.8' // use graph api version 2.8
    });
};
(function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s);
    js.id = id;
    js.src = "//connect.facebook.net/cs_CZ/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

Vue.use(FBSignInButton);

VueCookies.config('7d')
Vue.use(VueCookies);

Vue.use(Vuetify, {
    theme: {
        primary: '#faba54',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#b71c1c'
    }
})

Vue.use(VuetifyGoogleAutocomplete, {
    // apiKey: 'AIzaSyA1S5Dt528rTM48us2Voqvq-1eOd_zRbm4',
    apiKey: 'AIzaSyDKIl2uWNu7HRs5GpJd1DcDW5zch8_Mpew',
});

Vue.config.productionTip = false

accounting.settings = {
    currency: {
        symbol: "Kč",   // default currency symbol is '$'
        format: "%v %s", // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: ".",  // decimal point separator
        thousand: " ",  // thousands separator
        precision: 0   // decimal places
    },
    number: {
        precision: 0,  // default precision on numbers is 0
        thousand: " ",
        decimal: "."
    }
}

Vue.filter('formatPrice', function (value) {
    return accounting.formatMoney(value);
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>',
    store
})



// WEBPACK FOOTER //
// ./src/main.js